var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeOrange(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 24,
    viewBox: "0 0 34 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6461 16.3099V6.95684C16.9664 8.51922 19.538 10.0285 22.5795 11.6557C20.0709 13.0469 16.9664 14.6079 13.6461 16.3099ZM32.1504 2.30515C31.5776 1.55055 30.6014 0.963156 29.5622 0.768689C26.5075 0.188606 7.45034 0.186956 4.39728 0.768689C3.56388 0.924922 2.82176 1.30256 2.18425 1.88929C-0.501906 4.38246 0.339808 17.7525 0.987276 19.9183C1.25954 20.8557 1.61151 21.5318 2.05478 21.9755C2.62588 22.5623 3.40781 22.9663 4.30596 23.1474C6.82112 23.6677 19.7788 23.9585 29.509 23.2255C30.4055 23.0693 31.1991 22.6523 31.825 22.0407C34.3086 19.5575 34.1393 5.43656 32.1504 2.30515Z",
    fill: "#FF5D0E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeOrange);
export default __webpack_public_path__ + "static/media/YoutubeOrange.a1861b3f6314425eda9ab0a653d6a2c6.svg";
export { ForwardRef as ReactComponent };